// Full modified DepartmentCreation component

import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import DynamicForm from '../common/DynamicForm';
import LoaderComponent from "../../../libraries/loader/loader";
import { Fetchexecutequery, Fetchheaderdata, Fetchupdatequery } from '../../../services/process/BRS1/brsService7';
import { CreateData } from '../../../services/process/process_data/process_data';
import { Icon } from 'semantic-ui-react';
import Select from "react-select";

function DepartmentCreation() {
  const [formData, setFormData] = useState({});
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [fields, setFields] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [error, setError] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [optionslist, setOptionslist] = useState([]);
  const [selectedOption, setSelectedOption] = useState({value: 'Purchase Order Number', label: 'Purchase Order Number'});
  const [popupData, setPopupData] = useState({
    purchase_order_number: '',
    purchase_order_amount: '',
    description: '',
    milestone_percent: '',
    milestone_percent_value: '',
    selectType: 'Single',
  });

  const [popupRows, setPopupRows] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const gridRef = useRef();

  useEffect(() => {
    initialize();
    fetchstatuscolumntypeslist();
    setShowPopup(false);
  }, []);

const handlePopupRowChange = (index, field, value) => {
  setPopupRows(prevRows => {
    const newRows = [...prevRows];

    if (newRows[index].id) {
      newRows[index].isModified = true; // mark as modified
    }

    // ---- CASE 1: When percentage field changes ----
    if (field === 'milestone_percent') {
      let perc = parseFloat(value);

      if (value === '') {
        newRows[index][field] = value;
        newRows[index].milestone_percent_value = '0.00';
        return newRows;
      }

      if (isNaN(perc)) perc = 0;
      if (perc < 0) perc = 0;
      if (perc > 100) perc = 100;

      // Check total % constraint
      const currentTotal = newRows.reduce((sum, row, i) => {
        return sum + (i === index ? perc : parseFloat(row.milestone_percent) || 0);
      }, 0);

      if (currentTotal > 100) {
        alert(`Total milestone percent exceeds 100% (Current total: ${currentTotal}%). Please adjust.`);
        return prevRows; // discard change
      }

      newRows[index][field] = perc;

      const poAmt = parseFloat(newRows[index].po_contract_amount) || 0;
      newRows[index].milestone_percent_value = ((perc / 100) * poAmt).toFixed(2);
    }

    // ---- CASE 2: When value field changes ----
    else if (field === 'milestone_percent_value') {
  let val = parseFloat(value);

  if (value === '') {
    newRows[index][field] = value;
    newRows[index].milestone_percent = 0;
    return newRows;
  }

  if (isNaN(val) || val < 0) val = 0;

  const poAmt = parseFloat(newRows[index].po_contract_amount) || 0;

  // clamp amount to PO amount
  if (val > poAmt) val = poAmt;

  let perc = poAmt ? (val / poAmt) * 100 : 0;

  // clamp % to remaining total
  const otherTotal = newRows.reduce((sum, row, i) => i !== index ? parseFloat(row.milestone_percent) || 0 : 0, 0);
  const maxPercAllowed = Math.min(100 - otherTotal, 100);
  if (perc > maxPercAllowed) perc = maxPercAllowed;

  // ROUND % to 2 decimals
  perc = Math.round(perc * 100) / 100;
      const currentTotal = newRows.reduce((sum, row, i) => {
        return sum + (i === index ? val : parseFloat(row.milestone_percent_value) || 0);
      }, 0);

      if (currentTotal > poAmt) {
        alert(`Total milestone percent exceeds Rs.${poAmt}(Current total: Rs.${currentTotal}). Please adjust.`);
        return prevRows; // discard change
      }


  newRows[index].milestone_percent_value = val; // raw number
  newRows[index].milestone_percent = perc; // rounded to 2 decimals
}

    // ---- CASE 3: For other fields ----
    else {
      newRows[index][field] = value;
    }

    return newRows;
  });
};

const fetchPopupRows = async (purchase_order_number, type) => {
  const payload = {
    query: `SELECT * FROM payments.payment_details WHERE po_contract_number = '${purchase_order_number}';`
  };

  try {
    const FileUploadCredentials = Fetchexecutequery();
    const response = await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
    const data = response.data;
    console.log("payload", data);
const rows = (Array.isArray(data) && data.length > 0)
  ? data.map((item) => ({
      id: item.id,
      po_contract_number: item.po_contract_number,
      po_contract_amount: item.po_contract_amount,
      milestone_detail: item.milestone_detail || '',
      milestone_percent: type === 'Single' ? 100 : (item.milestone_percent || ''),
      milestone_percent_value: item.milestone_percent_value || '',
    }))
  : [];

    console.log("payload", payload, rows, response);
    setPopupRows(rows);
    
  } catch (error) {
    console.error("Failed to fetch popup rows:", error);
  }
};


const addPopupRow = () => {
  const totalUsedAmount = popupRows.reduce((acc, row) => acc + parseFloat(row.milestone_percent_value|| 0), 0);
  const remainingAmount = parseFloat(popupData.provision_cost || 0) - totalUsedAmount;
  console.log("remaining amount",totalUsedAmount,remainingAmount,popupRows,popupData);
  if ( (popupData.selectType === 'Single' && popupRows.length >= 1) || 
    remainingAmount <= 0) {
    return alert("Purchase amount fully utilized");
  }

  const newRow = {
    po_contract_number: popupData.purchase_order_number || '',
    po_contract_amount: popupData.provision_cost || '',
    milestone_detail: '',
    milestone_percent: popupData.selectType === 'Single' ? 100 : '',
    milestone_percent_value: ''
  };
  if (popupData.selectType === 'Single') {
    const poAmt = parseFloat(popupData.purchase_order_amount) || 0;
    newRow.milestone_percent_value = (poAmt).toFixed(2);
  }

  setPopupRows((prev) => [...prev, newRow]);
};

  const createPayload = (database, table, formData) => ({
    database,
    table,
    formData,
  });

  const makeApiRequest = (url, payload, headers) => {
    return axios.post(url, payload, headers)
      .then(response => {
        console.log("API Response:", response);
      })
      .catch(error => {
        console.error("API Error:", error);
        throw new Error("Error with API call");
      });
  };

const handleSaveSplitRows = async () => {
  console.log(popupData,popupRows)
  const rowsToSave = popupRows.filter(row => !row.id);    // New rows
  const rowsToUpdate = popupRows.filter(row => row.id  && row.isModified);   // Existing rows

  const formattedDate = getFormattedDate();
  let type = 'is_purchase_order';
  if (selectedOption.value === 'Contract'){
    type = 'is_contract_order';
  }

  if (popupRows.length === 0) {
    alert("Please add at least one milestone row before saving.");
    return;  // stop execution
  }

  for (const row of rowsToSave) {
   console.log("save rows",row);
  if ( !row.milestone_detail || row.milestone_detail.trim() === '') {
    alert("Please add milestone detail before saving.");
    return;  // stop execution
  }

    const newRowData = {
      ...row,
      created_date: formattedDate,
      modified_date: formattedDate,
      tenant_id: userCredentials.tenants_id,
      entity_id: userCredentials.selectedentity,
      group_id: userCredentials.groups_id,
      created_by: userCredentials.user_id,
      modified_by: userCredentials.user_id,
      [type]:1,status:'Open',po_type: formData.purchase_order_type,po_id:formData.id
    };

    const payload = createPayload('payments', 'payment_details', newRowData);
    const Creatingurl = CreateData();

    await makeApiRequest(Creatingurl[1], payload, Creatingurl[0]);
  }


  // ?? Update existing rows (1 request per row)
  for (const row of rowsToUpdate) {
    const updatedRecord = {
      milestone_detail: row.milestone_detail,
      milestone_percent: row.milestone_percent,
      milestone_percent_value: row.value,
      modified_date: formattedDate,
      modified_by: userCredentials.user_id,po_type: formData.purchase_order_type,po_id:formData.id
    };


    const payload = {
      schema_name: "payments",
      table: "payment_details",
      set_column: updatedRecord,
      where: [{ id: row.id }],    // condition for this row
    };

    console.log("Update payload:", payload);

    const FileUploadCredentials = Fetchupdatequery();
    await makeApiRequest(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
  }

let settype='is_single';
let settype1 ='is_multiple';

if (popupData.selectType === 'Multiple'){
       settype = 'is_multiple';
       settype1 = 'is_single';
}

    console.log("Updated purchase order:", popupData);
    const updatedRecord = {
         [settype]:1,
         [settype1]:0,
    };

    const payload = {
      schema_name: "payments",
      table: "purchase_order",
      set_column: updatedRecord,
      where: [{ "purchase_order_number": popupData.purchase_order_number }],    // condition for this row
    };

    console.log("Update payload:", payload,popupData);

    const FileUploadCredentials = Fetchupdatequery();
    await makeApiRequest(FileUploadCredentials[1], payload, FileUploadCredentials[0]);


  if (gridRef.current) {
    gridRef.current.api.deselectAll();
  }
  setShowPopup(false);
  fetchFieldInfo2({value: 'Purchase Order Number', label: 'Purchase Order Number'});
};

  const initialize = async () => {
    try {
      await Promise.all([fetchFieldInfo1(), fetchFieldInfo2({value: 'Purchase Order Number', label: 'Purchase Order Number'})]);
    } catch (err) {
      setError("Initialization failed");
    } finally {
      setLoading(false);
    }
  };

  const getFormattedDate = () => {
    const currentDate = new Date();
    return currentDate.toISOString().slice(0, 19).replace("T", " ");
  };

  const fetchstatuscolumntypeslist = () => {
    let data1 = ['Purchase Order Number', 'Contract'];
    const dropdownOptions = data1.map((item) => ({ value: item, label: item }));
    setOptionslist(dropdownOptions);
  };


  const formatColumnName = (name) =>
    name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

  const fetchFieldInfo1 = async () => {
    const payload = { headerconfig_id: 55, "filterconditions": [] };
    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
      const data = response.data;
      if (data.fields && data.fields.length > 0) {
        const columns = [
          {
            headerName: '',
            checkboxSelection: true,
            headerCheckboxSelection: true,
            width: 50
          },
          ...data.fields.map((field) => ({
            headerName: formatColumnName(field.renameValue || field.columnName),
            field: field.columnName,
            sortable: true,
            filter: true,
            resizable: true,
            width: 300
          }))
        ];
        setColumnDefs(columns);
        setFields(data.fields);
      }
    } catch (error) {
      console.error("Error fetching field info:", error);
      setError("Error fetching fields data");
    }
  };

  const handleEditClick = (row) => {
    setFormData(row);
    setEditMode(true);
  };

  const handleCheckboxChange_123 = (event) => {
    const selectedRow =  event.api.getSelectedRows()[0];
    if (!selectedRow) return;
    if (selectedRow.is_transaction_locked_purchase !== 0) {
      alert(`${selectedRow.working_person_name} ${selectedRow.working_person_last_name} is working on this transaction`);
    } else {
      setFormData(selectedRow);
    }
  };


const handleCheckboxChange = async(event) => {
  const selectedRows = event.api.getSelectedRows();
  const selectedRow = selectedRows.length > 0 ? selectedRows[0] : null;
  if (!selectedRow) {
    // No row selected � hide popup or reset state
    setShowPopup(false);
    return;
  }
console.log("selectedRow",selectedRow)
  // Check if transaction is locked
  if (selectedRow.is_transaction_locked_purchase !== 0) {
    alert(`${selectedRow.working_person_name} ${selectedRow.working_person_last_name} is working on this transaction`);
    return;
  }

  // Update state with selected row
  setFormData(selectedRow);
  let selecttype = 'Single';
  if (selectedRow.is_multiple === 1) {
    selecttype = 'Multiple' } 

setPopupData({
  purchase_order_number: selectedRow.purchase_order_number || '',
  purchase_order_amount: selectedRow.provision_cost || '',
  milestone_detail: '',
  milestone_percent: '',
  provision_cost : selectedRow.provision_cost || '',
  milestone_percent_value: '',
  selectType: selecttype,
});

  setShowPopup(true);
  fetchPopupRows(selectedRow.purchase_order_number,selecttype);
};

const handlePopupInputChange = (name, value) => {
  const updatedData = {
    ...popupData,
    [name]: value,
  };

  // When changing to Single, validate
  if (name === 'selectType' && value === 'Single') {
    const hasNon100 = popupRows.some(row => parseFloat(row.milestone_percent) !== 100);

    if (popupRows.length > 0 && hasNon100) {
      alert("Invoice already exists, can't change it to Single.");
      return; // Don't change selectType or rows
    }

    // Add single 100% row if no existing rows or only valid ones
    const poAmount = parseFloat(updatedData.purchase_order_amount) || 0;

    const exists100 = popupRows.some(row => parseFloat(row.milestone_percent) === 100);

    if (!exists100) {
      const singleRow = {
        id: null,
        po_contract_number: updatedData.purchase_order_number || '',
        po_contract_amount: updatedData.purchase_order_amount || '',
        milestone_detail: '',
        milestone_percent: 100,
        milestone_percent_value: poAmount.toFixed(2),
      };

      setPopupRows(prevRows => [...prevRows, singleRow]);
    }
  }

  setPopupData(updatedData);
  console.log("popup data", popupData, name, value);
};

const closePopup = () => {
  setShowPopup(false);
  setPopupData({
    purchase_order_number: '',
    purchase_order_amount: '',
    milestone_detail: '',
    milestone_percent: '',
    milestone_percent_value: '',
    selectType: 'Single',
  });
  if (gridRef.current) {
    gridRef.current.api.deselectAll();
  }
};

  const dropdownSelection = (event) => {
     console.log("selected option",event)
     setSelectedOption(event);
     let type = event.label
     fetchFieldInfo2(event)
  };


  const fetchFieldInfo2 = async (setopt) => {

    const isPurchaseOrderFlag = setopt.value === 'Contract' ? 0 : 1;
    const divisionid = userCredentials.division.join(","); 
const payload = {
  query: `
    SELECT 
      po.id,
      po.is_transaction_locked_purchase,
      po.working_person_purchase,
      u.first_name AS working_person_name,
      u.last_name AS working_person_last_name,
      IFNULL(TRIM(po.month), '') AS month,
      IFNULL(TRIM(po.purchase_order_number), '') AS purchase_order_number,
      IFNULL(DATE_FORMAT(po.po_date, '%d-%m-%Y'), '') AS po_date,
      IFNULL(DATE_FORMAT(po.po_expiry_date, '%d-%m-%Y'), '') AS po_expiry_date,
      IFNULL(TRIM(po.vendor_code), '') AS vendor_code,
      IFNULL(TRIM(po.vendor_name), '') AS vendor_name,
      IFNULL(TRIM(po.po_purpose), '') AS po_purpose,
      IFNULL(TRIM(po.delivery_location), '') AS delivery_location,
      IFNULL(TRIM(po.po_kind), '') AS po_kind,
      IFNULL(TRIM(po.expense_category), '') AS expense_category,
      IFNULL(TRIM(po.department_category), '') AS department_category,
      IFNULL(TRIM(po.sbu_head), '') AS sbu_head,
      IFNULL(TRIM(po.cost_code), '') AS cost_code,
      IFNULL(CONVERT(po.provision_cost, CHAR), '0.00') AS provision_cost,
      IFNULL(CONVERT(po.provision_amount, CHAR), '0.00') AS provision_amount,
      IFNULL(CONVERT(po.gst_amount, CHAR), '0.00') AS gst_amount,
      IFNULL(CONVERT(po.total_po_value, CHAR), '0.00') AS total_po_value,
      IFNULL(TRIM(po.po_requestor), '') AS po_requestor,
      IFNULL(TRIM(po.po_type), '') AS po_type,
      IFNULL(TRIM(po.prepared_by), '') AS prepared_by,
      IFNULL(TRIM(po.cross_checked_by), '') AS cross_checked_by,
      IFNULL(TRIM(po.po_status_approved_by), '') AS po_status_approved_by,
      IFNULL(TRIM(po.payment_terms), '') AS payment_terms,
      IFNULL(TRIM(po.delivery_period), '') AS delivery_period,
      IFNULL(TRIM(po.invoice_number), '') AS invoice_number,
      IFNULL(CONVERT(po.invoice_amount, CHAR), '0.00') AS invoice_amount,
      IFNULL(CONVERT(po.difference_amount, CHAR), '') AS difference_amount,
      IFNULL(TRIM(po.status), '') AS status,
      IFNULL(TRIM(po.ap_module_ibn), '') AS ap_module_ibn,
      IFNULL(TRIM(po.budgeted_or_not_budgeted), '') AS budgeted_or_not_budgeted,
      po.is_multiple AS is_multiple,po.purchase_order_type,
      po.is_single,po.id,
      -- milestone sum from payment_details
      IFNULL(SUM(pd.milestone_percent_value), 0) AS milestone_value,
      -- difference between provision_cost and milestone_value
      (po.provision_cost - IFNULL(SUM(pd.milestone_percent_value), 0)) AS remaining_difference
    FROM payments.purchase_order po
    LEFT JOIN payments.users u 
      ON u.id = ${userCredentials.user_id}
    LEFT JOIN payments.payment_details pd 
      ON pd.po_contract_number = po.purchase_order_number
    WHERE po.is_purchase_order = ${isPurchaseOrderFlag}
      AND po.purchase_order_type IN (
        SELECT name 
        FROM user_management_uat.divisions 
        WHERE division_id IN (${divisionid})
      )
      AND po.entity_id = ${userCredentials.selectedentity}
      AND po.is_active = 1 
      AND po.po_expiry_date >= NOW()
    GROUP BY po.id
    HAVING remaining_difference > 0;
  `
    };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
      const data = response.data;
      if (data && data.length > 0) {
        setRowData(data);
      } else {
	setRowData([]);
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
  };


  const handleInputChange = (name, value) => {
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const onFilterTextChange = (event) => {
    setSearchText(event.target.value);
  };

  if (loading) return <LoaderComponent loaderOpen={true} />;

  return (
    <div>
      <h2 className="pt-1 pb-1 text-center" style={{ color: "#4969ab", fontSize: '18px' }}>
        MILESTONES
      </h2>
<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginLeft: '1em', marginRight: '1em' }}>
  <div style={{ width: "15%" }}>
    <Select
      clearable
      options={optionslist}
      selection
      size='mini'
      onChange={dropdownSelection}
      value={selectedOption}
    />
  </div>
  <div>
    <input
      className="search-input"
      type="text"
      placeholder="Search..."
      value={searchText}
      onChange={onFilterTextChange}
      style={{
        width: '300px',  // fixed width instead of percentage for cleaner alignment
        backgroundColor: 'white',
        marginLeft: '8px',
        padding: '8px',
        borderRadius: '4px',
        border: '1px solid #ced4da',
      }}
    />
  </div>
</div>


      {error && <div style={{ color: "red" }}>{error}</div>}

{showPopup && (
  <div
    style={{
      position: 'fixed',
      top: '10%',
      left: '30%',
      width: '50%',
      maxHeight: '90vh',
      overflowY: 'auto',
      background: '#fff',
      padding: '20px',
      border: '2px solid #ccc',
      borderRadius: '10px',
      zIndex: 9999,
      boxShadow: '0 0 10px rgba(0,0,0,0.3)'
    }}
  >
    <h4 style={{ marginBottom: '15px', color: '#2a4d8c', fontWeight: '600' }}>Transaction Input</h4>

    <div className="form-group" style={{ marginBottom: '15px' }}>
      <label style={{ fontWeight: '500' }}>Select Type:</label>
      <select
        className="form-control"
        value={popupData.selectType}
        onChange={(e) => handlePopupInputChange('selectType', e.target.value)}
        style={{
          padding: '6px',
          borderRadius: '4px',
          border: '1px solid #ccc'
        }}
      >
        <option value="Single">Single</option>
        <option value="Multiple">Multiple</option>
      </select>
    </div>

    {popupRows.map((row, index) => {
      const isClosed = row.status === 'Closed';
      return (
        <div
          key={index}
          style={{
            display: 'flex',
            gap: '10px',
            marginBottom: '12px',
            padding: '10px',
            borderRadius: '6px',
            border: '1px solid #e0e0e0',
            backgroundColor: isClosed ? '#f9f9f9' : '#fff',
            opacity: isClosed ? 0.7 : 1
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ fontSize: '11px', fontWeight: '500' }}>PO Number</label>
            <input
              value={row.po_contract_number}
              readOnly
              style={{
                width: '200px',
                backgroundColor: '#f0f2f5',
                border: '1px solid #ccc',
                padding: '4px 6px',
                borderRadius: '4px'
              }}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ fontSize: '11px', fontWeight: '500' }}>PO Amount</label>
            <input
              value={row.po_contract_amount}
              readOnly
              style={{
                width: '100px',
                backgroundColor: '#f0f2f5',
                border: '1px solid #ccc',
                padding: '4px 6px',
                borderRadius: '4px'
              }}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ fontSize: '11px', fontWeight: '500' }}>Description</label>
            <input
              placeholder="Description"
              value={row.milestone_detail}
              onChange={(e) => handlePopupRowChange(index, 'milestone_detail', e.target.value)}
              disabled={isClosed}
              style={{
                width: '160px',
                backgroundColor: isClosed ? '#ececec' : '#fff',
                border: '1px solid #ccc',
                padding: '4px 6px',
                borderRadius: '4px'
              }}
            />
          </div>

<div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ fontSize: '11px', fontWeight: '500' }}>% of Amount</label>
            <input
              type="number"
              placeholder="%"
              value={row.milestone_percent}
              min="1"
              max="100"
              onChange={(e) => handlePopupRowChange(index, 'milestone_percent', e.target.value)}
              disabled={isClosed  || popupData.selectType === 'Single'}
              style={{
                width: '80px',
                backgroundColor: isClosed || popupData.selectType === 'Single' ? '#ececec' : '#fff',
                border: '1px solid #ccc',
                padding: '4px 6px',
                borderRadius: '4px'
              }}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ fontSize: '11px', fontWeight: '500' }}>Amount</label>
            <input
              type="number"
              placeholder="Amount"
              value={row.milestone_percent_value}
              onChange={(e) => handlePopupRowChange(index, 'milestone_percent_value', e.target.value)}
              disabled={isClosed  || popupData.selectType === 'Single'}
              style={{
                width: '100px',
                backgroundColor: isClosed || popupData.selectType === 'Single' ? '#ececec' : '#fff',
                border: '1px solid #ccc',
                padding: '4px 6px',
                borderRadius: '4px'
              }}

            />
          </div>
        </div>
      );
    })}

    {popupData.selectType === 'Multiple' && (
        <button type="submit" className="submit-btn" style={{ width: "100px", height:"33px" }} onClick={addPopupRow}>
          Add Row
        </button>
    )}

    {popupData.selectType === 'Single' && popupRows.length === 0 && (
        <button type="submit" className="submit-btn" style={{ width: "100px", height:"33px" }} onClick={addPopupRow}>
          Add Row
        </button>
    )}

    <div>
        <button type="submit" className="submit-btn" style={{ width: "100px", height:"33px" }} onClick={handleSaveSplitRows}>
          Save
        </button>

        <button type="submit" className="submit-btn" style={{ width: "100px", height:"33px" }} onClick={closePopup}>
          Close
        </button>

      </div>
  </div>
)}


      <div style={{ display: 'flex', justifyContent: 'center' }}>
        {(!columnDefs.length) ? (
          <div>Loading or no data available</div>
        ) : (
          <div
            className="ag-theme-alpine"
            style={{
              overflowX: 'auto',
              overflowY: 'auto',
              borderRadius: '10px',
              width: `${columnDefs.length * 250}px`,
              maxWidth: '100%',
              height: '580px',
              margin: '10px',
              marginTop:'30px'
            }}
          >
            <AgGridReact
              ref={gridRef}
              columnDefs={columnDefs}
              rowData={rowData}
              quickFilterText={searchText}
              filter={true}
              animateRows={true}
              pagination={true}
              paginationPageSize={12}
              rowSelection={'single'}
              onSelectionChanged={handleCheckboxChange}
              enableCellTextSelection= {true}
              suppressRowClickSelection={true}

            />
          </div>
        )}
      </div>
    </div>
  );
}

export default DepartmentCreation;